// 共通の地図閲覧権限判定ロジック

// "YYYY-MM-DD"形式の文字列を日本時間としてパースする
const parseLocalDate = (dateStr: string): Date => {
  return new Date(`${dateStr}T00:00:00+09:00`);
};

// 現在の日本時間の日付を "YYYY-MM-DD" 形式で取得し、Dateオブジェクトとして返す
const getNowInJST = (): Date => {
  const now = new Date();
  // 日本時間での日付文字列を取得（例: "2025-12-26"）
  const jstDateStr = now
    .toLocaleDateString("ja-JP", {
      timeZone: "Asia/Tokyo",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .replace(/\//g, "-");
  // parseLocalDateと同じ方法でパースして、比較時のタイムゾーンを統一
  return parseLocalDate(jstDateStr);
};

// 契約期間の判定ロジック（本契約中 または トライアル期間中）
const isContractActive = ({
  contractStartDate,
  contractEndDate,
  trialStartDate,
  trialEndDate,
}: {
  contractStartDate: string | null;
  contractEndDate: string | null;
  trialStartDate: string | null;
  trialEndDate: string | null;
}): boolean => {
  const now = getNowInJST();

  // 本契約中の判定
  if (contractStartDate) {
    const contractStart = parseLocalDate(contractStartDate);
    if (contractStart <= now) {
      // contractEndDateがある場合は終了日をチェック
      if (contractEndDate) {
        const contractEnd = parseLocalDate(contractEndDate);
        // 終了日を丸1日有効とするため、終了日の時刻を当日の最終時刻に設定
        contractEnd.setHours(23, 59, 59, 999);
        if (now <= contractEnd) {
          return true;
        }
        // contractEndDateを過ぎている場合は契約終了
      } else {
        // contractEndDateがnullの場合はcontractStartDateのみで判定（無期限契約）
        return true;
      }
    }
  }

  // トライアル期間中の判定
  if (trialStartDate && trialEndDate) {
    const trialStart = parseLocalDate(trialStartDate);
    const trialEnd = parseLocalDate(trialEndDate);
    // トライアル終了日時を丸1日有効とするため、終了日の時刻を当日の最終時刻に設定
    trialEnd.setHours(23, 59, 59, 999);

    if (now >= trialStart && now <= trialEnd) {
      return true;
    }
  }

  return false;
};

// Geospace用の権限判定（appIdが必須）
export const determineMapServicePermission = ({
  appId,
  contractStartDate,
  contractEndDate,
  trialStartDate,
  trialEndDate,
}: {
  appId: string | null;
  contractStartDate: string | null;
  contractEndDate: string | null;
  trialStartDate: string | null;
  trialEndDate: string | null;
}): boolean => {
  if (!appId) return false;

  if (
    isContractActive({
      contractStartDate,
      contractEndDate,
      trialStartDate,
      trialEndDate,
    })
  ) {
    return true;
  }

  // NOTE: 再ログイン前のユーザーは従来のロジックで判定する
  if (!(!!contractStartDate || !!trialStartDate || !!trialEndDate)) {
    return true;
  }

  return false;
};

// ゼンリン用の権限判定（本契約中 または トライアル期間中）
export const determineZenrinPermission = ({
  contractStartDate,
  contractEndDate,
  trialStartDate,
  trialEndDate,
}: {
  contractStartDate: string | null;
  contractEndDate: string | null;
  trialStartDate: string | null;
  trialEndDate: string | null;
}): boolean => {
  return isContractActive({
    contractStartDate,
    contractEndDate,
    trialStartDate,
    trialEndDate,
  });
};
